
import { useStormTradeParticipantListInfiniteQuery } from '@query/story';

import StepsToJoinCampaign from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';
import { stepsToJoinStormTradeCampaign } from './data';

const StepsToJoinStormTradeCampaign = () => {
  const { data } = useStormTradeParticipantListInfiniteQuery();
  const campaignUrl = data?.pages[0]?.meta.campaign || '#';

  return <StepsToJoinCampaign campaignUrl={campaignUrl} steps={stepsToJoinStormTradeCampaign} />;
};

export default StepsToJoinStormTradeCampaign;
